<template>
  <div class="customer-odonto-implants">
    <customer-show-odonto-implant ref="showimplant" :customer="customer"
      @submit="loadImplants"></customer-show-odonto-implant>
    <!-- ODONTOGRAM ROW -->
    <div class="customer-odonto-implants__info">
      <strong>Selecciona una pieza para mostrar sus Implantes o crear uno nuevo</strong>
      <div>
        <transition name="fade">
          <button v-if="this.selected_tooth.length" @click="clearSelected" class="btn btn-wabident-round mx-1">
            <i class="fas fa-undo"></i> Borrar selección
          </button>
        </transition>
        <transition name="fade">
          <button v-if="this.selected_tooth.length" @click="createImplant" class="btn btn-wabident-round mx-1">
            <i class="fas fa-plus"></i>
            Crear Implante
          </button>
        </transition>
      </div>
    </div>
    <div class="customer-odonto-implants__odontogram">
      <!-- UPPER ROW -->
      <div class="customer-odonto-implants__odontogram-row">
        <div v-for="tooth, index in upper_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-odonto-implants__odontogram-tooth upper" :class="{ selected: isSelected(tooth) }">
          <img :src="'/odontogram-v2/' + tooth + '.svg'">
          <div v-if="active_implants_map[tooth]" class="customer-odonto-implants__screw upper">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8 5C8 4.44772 8.44772 4 9 4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H9C8.44772 6 8 5.55228 8 5ZM8 9C8 8.44772 8.44772 8 9 8H22C22.5523 8 23 8.44772 23 9C23 9.55228 22.5523 10 22 10H9C8.44772 10 8 9.55228 8 9ZM8 13C8 12.4477 8.44772 12 9 12H22C22.5523 12 23 12.4477 23 13C23 13.5523 22.5523 14 22 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H22C22.5523 16 23 16.4477 23 17C23 17.5523 22.5523 18 22 18H9C8.44772 18 8 17.5523 8 17ZM8 21C8 20.4477 8.44772 20 9 20H22C22.5523 20 23 20.4477 23 21C23 21.5523 22.5523 22 22 22H9C8.44772 22 8 21.5523 8 21ZM8 25C8 24.4477 8.44772 24 9 24H22C22.5523 24 23 24.4477 23 25C23 25.5523 22.5523 26 22 26H9C8.44772 26 8 25.5523 8 25Z"
                fill="black" />
            </svg>
          </div>
        </div>
      </div>
      <!-- LOWER ROW -->
      <div class="customer-odonto-implants__odontogram-row">
        <div v-for="tooth, index in lower_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-odonto-implants__odontogram-tooth lower" :class="{ selected: isSelected(tooth) }">
          <img :src="'/odontogram-v2/' + tooth + '.svg'">
          <div v-if="active_implants_map[tooth]" class="customer-odonto-implants__screw lower">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8 5C8 4.44772 8.44772 4 9 4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H9C8.44772 6 8 5.55228 8 5ZM8 9C8 8.44772 8.44772 8 9 8H22C22.5523 8 23 8.44772 23 9C23 9.55228 22.5523 10 22 10H9C8.44772 10 8 9.55228 8 9ZM8 13C8 12.4477 8.44772 12 9 12H22C22.5523 12 23 12.4477 23 13C23 13.5523 22.5523 14 22 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H22C22.5523 16 23 16.4477 23 17C23 17.5523 22.5523 18 22 18H9C8.44772 18 8 17.5523 8 17ZM8 21C8 20.4477 8.44772 20 9 20H22C22.5523 20 23 20.4477 23 21C23 21.5523 22.5523 22 22 22H9C8.44772 22 8 21.5523 8 21ZM8 25C8 24.4477 8.44772 24 9 24H22C22.5523 24 23 24.4477 23 25C23 25.5523 22.5523 26 22 26H9C8.44772 26 8 25.5523 8 25Z"
                fill="black" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- implant LIST -->
    <div class="customer-odonto-implants__list">
      <table class="table table-search-results">
        <thead>
          <tr>
            <th>Activo</th>
            <th>F.Alta</th>
            <th>F.Colocación</th>
            <th>F.Fracaso</th>
            <th>Diente</th>
            <th>Modelo</th>
            <th>Notas</th>
            <th>U.Revisión</th>
            <th>Prox.Rev</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <customer-odonto-implant @edit="editImplant" @delete="deleteImplant" :selected_tooth="selected_tooth"
            v-for="implant in odonto_implants" :key="implant.id" :customer="customer"
            :implant="implant"></customer-odonto-implant>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      selected_tooth: [],
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // UPPER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // UPPER RIGHT
      ],
      implants: [],
    }
  },
  computed: {
    odonto_implants() {
      return this.implants;
    },
    upper_row_teeth() {
      return this.upper_row_adults;
    },
    lower_row_teeth() {
      return this.lower_row_adults;
    },
    active_implants_map() {
      let ret = {};

      this.odonto_implants.forEach(implant => {
        if (implant.status == 'active' && Number(implant.tooth) > 0) {
          ret[implant.tooth] = true;
        }
      });

      return ret;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    loadImplants() {
      this.clearSelected();
      axios.get(`/customer/${this.customer.id}/implants`).then((response) => {
        this.implants = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando Implantes. Por favor contacte con el Administrador')
      });
    },
    editImplant(implant) {
      this.$refs.showimplant.showEdit(implant);
    },
    deleteImplant(implant) {
      this.errorwindow.show('Confirmación', '¿Borrar el implante? Esta operación no es reversible.', 'Borrar', 'Cancelar', () => {
        this.doDeleteImplant(implant);
      })
    },
    doDeleteImplant(implant) {
      axios.post(`/customer/${this.customer.id}/implants/${implant.id}`, {
        '_method': 'delete'
      }).then((response) => {
        this.msgwindow.success('Implante borrado correctamente');
      }).catch((err) => {
        this.msgwindow.error('Error borrando el Implante, consulte con el Administrador');
      }).then(() => {
        this.loadImplants();
      })
    },
    clickTooth(tooth) {
      if (this.isSelected(tooth)) {
        this.selected_tooth = this.selected_tooth.filter((t) => {
          t != tooth;
        });
      } else {
        this.selected_tooth.push(tooth);
      }

      if (this.selected_tooth.length > 1) {
        this.selected_tooth.shift();
      }
    },
    clearSelected() {
      this.selected_tooth = [];
    },
    isSelected(tooth) {
      return this.selected_tooth.includes(tooth);
    },
    createImplant() {
      this.$refs.showimplant.showNew(this.selected_tooth);
    },
  },
  mounted() {
    this.loadImplants();
  }
}
</script>

<style lang="scss">
.customer-odonto-implants {
  display: flex;
  flex-flow: column nowrap;
  gap: 30px;
  padding: 30px;

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;
  }

  &__screw {
    position: absolute;
    width: 100%;
    max-width: 70px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    svg * {
      width: 100%;
      max-width: 70px;
      fill: var(--theme-text-color);
      transition: fill .3s;
    }

    &.upper {
      top: 60%;
    }

    &.lower {
      top: 40%;
    }
  }

  &__odontogram {
    width: 100%;
    position: relative;
    display: flex;
    flex-flow: row wrap;

    &:before {
      position: absolute;
      width: 100%;
      height: 1px;
      content: '';
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: var(--theme-shadow);
    }

    &:after {
      position: absolute;
      width: 1px;
      height: 100%;
      content: '';
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: var(--theme-shadow);
    }
  }

  &__odontogram-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;
  }

  &__odontogram-tooth {
    flex: 1 1 60px;
    position: relative;
    cursor: pointer;
    transition: background-color .3s;
    border-radius: 10px;

    /* Selected background */
    &.selected,
    &:hover {
      background-color: var(--theme-shadow);
    }

    &.selected svg * {
      fill: var(--theme-color);
    }

    /* Tooth image */
    img {
      box-sizing: border-box;
      width: 100%;
      padding: 10%;
      object-fit: contain;
      object-position: center center;
    }

    &.extracted img {
      opacity: 0.1;
    }

    /* Tooth label */
    &::before {
      content: attr(data-tooth);
      position: absolute;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      color: white;
      font-weight: 900;
      font-size: clamp(7px, 0.7vw, 14px);
      line-height: 1.5;
      transform: translateX(-50%);
      padding: 0 5px;
      background-color: var(--theme-color);
      z-index: 1;
    }

    &.upper::before {
      top: 10px;
    }

    &.lower::before {
      bottom: 10px;
    }
  }

  &__list {
    width: 100%;
    max-height: 50vh;
    overflow-y: scroll;

    table {
      thead {
        position: sticky;
        border-color: var(--theme-color);

        tr {
          background-color: var(--theme-color) !important;

          th {
            color: white;
            text-transform: uppercase;
            background-color: var(--theme-color);
            text-align: center;
            font-size: 15px;
          }
        }
      }

      tbody {
        tr {
          &.selected {
            background-color: var(--theme-shadow);
          }

          td {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
